<template>
  <div
    class="flex items-center text-sm gap-1"
  >
    <span class="iconify svg--truck-empty text-xs m-[1.5px] shrink-0" />
    <span v-if="!availabilityDate">
      <span class="font-bold">
        {{ $t('FREE DELIVERY') }}
      </span>
      <span>
        {{ $t('approx. Delivery date', { deliveryDate }) }}
      </span>
    </span>
    <span v-else>{{ availabilityDate }}</span>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ProductCardDelivery',
  props: {
    deliveryDate: {
      type: String,
      required: true,
    },
    availabilityDate: {
      type: String,
      required: true,
    },
  },
});

</script>
